import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  FOG_800M_COLOR,
  FOG_1600M_COLOR,
  FOG_3000M_COLOR,
  NO_FOG_COLOR,
  NO_DATA_COLOR
} from '../../theme/colors';
import * as styles from '../../styles/MapPageStyles';

interface StandaloneLegendProps {
  formatVisibility: (value: number) => string;
}

const StandaloneLegend: React.FC<StandaloneLegendProps> = ({ formatVisibility }) => {
  return (
    <Box sx={styles.standaloneLegendContainerStyles}>
      <Typography
        variant="subtitle1"
        sx={styles.legendTitleStyles}
      >
        Visibility
      </Typography>
      {/* Status indicator explanation */}
      <Box sx={styles.legendStatusContainerStyles}>
        <Box sx={styles.legendItemRowStyles}>
          <Box sx={styles.legendIconContainerStyles}>
            <svg width="100%" height="100%" viewBox="0 0 16 16">
              {/* Two half circles */}
              <defs>
                <clipPath id="standaloneLegendLeft">
                  <rect x="0" y="0" width="8" height="16" />
                </clipPath>
                <clipPath id="standaloneLegendRight">
                  <rect x="8" y="0" width="8" height="16" />
                </clipPath>
              </defs>
              <circle cx="8" cy="8" r="7" fill="#888" clipPath="url(#standaloneLegendLeft)" />
              <circle cx="8" cy="8" r="7" fill="#666" clipPath="url(#standaloneLegendRight)" />
              <circle cx="8" cy="8" r="7" fill="none" stroke="#FFF" strokeWidth="1.5" />
              <line x1="8" y1="1" x2="8" y2="15" stroke="#FFF" strokeWidth="1" opacity="0.7" />
            </svg>
          </Box>
          <Typography variant="caption" sx={styles.legendTextStyles}>
            Current | Forecast
          </Typography>
        </Box>
      </Box>

      {/* Vertical divider */}
      <Box sx={{
        width: '100%',
        height: '1px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        my: 1
      }} />

      <Box sx={styles.legendItemsContainerStyles}>
        <Box sx={styles.legendItemRowStyles}>
          <Box sx={styles.legendColorBoxStyles(FOG_800M_COLOR)} />
          <Typography variant="caption" sx={styles.legendTextStyles}>{`≤ ${formatVisibility(800)}`}</Typography>
        </Box>
        <Box sx={styles.legendItemRowStyles}>
          <Box sx={styles.legendColorBoxStyles(FOG_1600M_COLOR)} />
          <Typography variant="caption" sx={styles.legendTextStyles}>{`≤ ${formatVisibility(1600)}`}</Typography>
        </Box>
        <Box sx={styles.legendItemRowStyles}>
          <Box sx={styles.legendColorBoxStyles(FOG_3000M_COLOR)} />
          <Typography variant="caption" sx={styles.legendTextStyles}>{`≤ ${formatVisibility(3000)}`}</Typography>
        </Box>
        <Box sx={styles.legendItemRowStyles}>
          <Box sx={styles.legendColorBoxStyles(NO_FOG_COLOR)} />
          <Typography variant="caption" sx={styles.legendTextStyles}>&gt; 3000 m</Typography>
        </Box>
        <Box sx={styles.legendItemRowStyles}>
          <Box sx={styles.legendColorBoxStyles(NO_DATA_COLOR)} />
          <Typography variant="caption" sx={styles.legendTextStyles}>No data</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default StandaloneLegend;
